export const TRANSCRIPTION_SEGMENT_ID_ATTRIBUTE = 'lk.segment_id';
export const TRANSCRIPTION_FINAL_ATTRIBUTE = 'lk.transcription_final';

export const PARTICIPANT_IDENTITIES = {
  AGENT_PREFIX: 'agent-',
  CUSTOMER: 'customer',
  SIP_IDENTIFIER: 'sip',
  WEB_LISTENER: 'web-listener',
  /** Mirrors `buildSupervisorIdentity` in call-agent-api: `supervisor-<userId>-<sessionId>`. */
  SUPERVISOR_PREFIX: 'supervisor-',
} as const;
